import { createSlice } from "@reduxjs/toolkit";

const defaultLifeTimeStats = {
  totalDevices: 0,
  gateways: 0,
  totalCleaningSession: 0,
  waterSaved: 0,
  humanEffortSaved: 0
};

const defaultTodayStats = {
  cleaningSessions: 0,
  cleaningDuration: 0,
  waterSaved: 0,
  humanEffortSaved: 0
}


const siteSlice = createSlice({
  name: "site",
  initialState: {
    siteInfo: {},
    siteStats: {
      lifeTimeStats: defaultLifeTimeStats,
      todayStats: defaultTodayStats
    }
  },
  reducers: {
    updateSiteInfo(state, action) {
      state.siteInfo = action.payload;
    },
    updateSiteStats(state, action) {
      state.siteStats = action.payload;
    }
  },
});

export const siteActions = siteSlice.actions;

export default siteSlice;
